import { AppState } from "@auth0/auth0-react";
const ACCOUNT_REDIRECT_URL_KEY = "ACCOUNT_REDIRECT_URL";

export const setAccountRedirectUrl = (appState?: AppState) => {
  localStorage.setItem(ACCOUNT_REDIRECT_URL_KEY, appState?.returnTo ?? "/");
};

export const getAccountRedirectUrl = () => {
  return localStorage.getItem(ACCOUNT_REDIRECT_URL_KEY);
};

export const clearAccountRedirectUrl = () => {
  localStorage.removeItem(ACCOUNT_REDIRECT_URL_KEY);
};
